import { FC, useEffect } from 'react';
import ILSDocumentTypeSelect from '@modules/documents/components/document-type-select';
import { useAppDispatch } from '@core/hooks';
import { documentsIndexRoutine } from '@modules/documents/actions';
import { deletedDocumentsParams } from '@modules/documents/constants/document-params';

const ILSDocumentsTrash: FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(documentsIndexRoutine(deletedDocumentsParams));
  }, []);

  return (
    <ILSDocumentTypeSelect />
  );
};

export default ILSDocumentsTrash;
